<template>
  <el-dialog
    title="服务单评价"
    :visible.sync="show"
    width="600px"
    center
    @close="$emit('update:show', false)"
    @open="handle_open">
    <el-form ref="form" :model="rating_form" label-width="90px"
             v-loading="is_rating_info_loading"
             @submit.native.prevent
             element-loading-text="正在获取评价信息">
      <el-form-item label="评分">
        <el-rate class="custom_rate" v-model="rating_form.data.point" show-text
                 :texts="rating_form.info.point_remarks"/>
      </el-form-item>
      <el-form-item label="标签" v-loading="is_loading_more_tags">
        <el-checkbox-group
          v-model="rating_form.data.tag">
          <el-checkbox
            :key="tag"
            v-for="tag in rating_form.info.recent_used_tags"
            :label="tag"
            border/>
        </el-checkbox-group>
        <el-input
          class="input-new-tag"
          v-if="is_new_tag_input_visible"
          v-model="new_tag_title"
          ref="new_rate_tag"
          size="small"
          @keyup.enter.native.prevent.stop="handleAddNewTag"
          @blur.prevent.stop="handleAddNewTag"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showAddNewRateTagInput">添加新标签</el-button>
        <el-button v-if="rating_form.info.has_more_tags" class="button-load-more-tags" size="small"
                   @click="handleLoadMoreTags">加载更多标签
        </el-button>
      </el-form-item>
      <el-form-item label="说点啥">
        <el-input type="textarea"
                  autosize
                  rows="3"
                  v-model="rating_form.data.remark"
                  placeholder="亲,服务感受如何,说说他的优点或是不足吧!"/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" v-if="!is_rating_info_loading">
      <el-button @click="$emit('update:show', false)">暂不评分</el-button>
      <el-button type="primary" @click="handle_rate">立即评分</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {mapState, mapActions, mapGetters} from 'vuex';

  export default {
    name: 'rate-ticket-dialog',
    components: {},
    props: {
      show: {
        type: Boolean,
        default: false
      },
      ticket_id: {
        type: [Number, String]
      }
    },
    data() {
      return {
        rating_form: {
          info: {},
          data: {
            point: 0,
            remark: '',
            tag: []
          }
        },
        is_rating_info_loading: false,
        is_new_tag_input_visible: false,
        is_loading_more_tags: false,
        new_tag_title: '',
      }
    },
    computed: {
      ...mapGetters([
        'sp_id',
      ]),
    },
    watch: {},
    methods: {
      ...mapActions([
        'getRatingInfo',
        'getMoreRatingTags',
        'rateTicket',
      ]),
      async handleLoadMoreTags() {
        this.is_loading_more_tags = true;

        try {
          const {data} = await this.getMoreRatingTags({spId: this.sp_id});
          this.rating_form.info.has_more_tags.concat(data);

          this.rating_form.info.has_more_tags.filter((item, pos) => {
            return this.rating_form.info.has_more_tags.indexOf(item) === pos;
          });
        } catch (e) {
        }

        this.rating_form.info.has_more_tags = false;
        this.is_loading_more_tags = false;
      },
      showAddNewRateTagInput() {
        this.is_new_tag_input_visible = true;

        this.$nextTick(() => {
          this.$refs.new_rate_tag.$refs.input.focus();
        });
      },
      handleAddNewTag() {
        if (!this.new_tag_title || !this.new_tag_title.trim().length) {
          return;
        }

        if (this.rating_form.info.recent_used_tags.indexOf(this.new_tag_title) !== -1) {
          this.$message.error('标签已存在');
          return;
        }

        this.rating_form.info.recent_used_tags.push(this.new_tag_title);
        this.rating_form.data.tag.push(this.new_tag_title);
        this.is_new_tag_input_visible = false;
        this.new_tag_title = '';
      },
      async handle_rate() {
        if (this.rating_form.data.point <= 0) {
          this.$message.error("请评分！");
          return;
        }

        try {
          await this.rateTicket({
            ...this.rating_form.data,
            sp_id: this.sp_id,
            ticket_id: this.ticket_id
          });
          this.$emit('update:show', false);
        } catch (e) {
        }
      },
      async handle_open() {
        if (!this.ticket_id) {
          this.$emit('update:show', false);
          return;
        }

        this.is_rating_info_loading = true;

        try {
          const {data} = await this.getRatingInfo({ticketId: this.ticket_id});
          this.rating_form.info = data;
          this.rating_form.info.point_remarks = data.remarks.map(item => item.remark);
          this.rating_form.info.has_more_tags = data.recent_used_tags.length <= 10;
        } catch (e) {
        }

        this.is_rating_info_loading = false;
      },
    },
    mounted() {
    }
  }
</script>

<style scoped>
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    vertical-align: middle;
  }

  .custom_rate {
    padding-top: 10px;
  }

  .el-checkbox-group > .el-checkbox {
    margin-left: 0 !important;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/controls/rate-ticket-dialog.vue